import React from 'react';
import { getCategoryLabel } from '../../data/analyzerRules';

const RuleTooltip = ({ issue, children }) => {
  const description = issue?.description || 'No description available.';
  const recommendation = issue?.recommendation || 'No recommendation available.';

  return (
    <span className="relative inline-flex items-center group">
      {children}
      <span className="pointer-events-none absolute left-0 top-full mt-2 w-72 rounded-lg shadow-xl p-3 text-xs opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity z-20" style={{background:'var(--tqa-surface-3)',border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.75)'}}>
        <div className="text-[11px] uppercase tracking-wide mb-1" style={{color:'rgba(255,255,255,0.4)'}}>Rule</div>
        <div className="text-sm font-semibold mb-1" style={{color:'rgba(255,255,255,0.9)'}}>{issue?.errorCode || 'Unknown'}</div>
        <div className="text-[11px] mb-2" style={{color:'rgba(255,255,255,0.45)'}}>{getCategoryLabel(issue?.errorCode)}</div>
        <div className="text-xs mb-2" style={{color:'rgba(255,255,255,0.7)'}}>{description}</div>
        <div className="text-xs" style={{color:'rgba(255,255,255,0.7)'}}>
          <span className="text-[11px] uppercase tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>Recommendation</span>
          <div>{recommendation}</div>
        </div>
      </span>
    </span>
  );
};

export default RuleTooltip;
